import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-042ba644"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "CallsComponent"
};
var _hoisted_2 = {
  "class": "CallsComponent__title"
};
var _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"CallsComponent__minortitle\" data-v-042ba644>Your AIVitar can now schedule your appointments and simple and mundane tasks for you!</div><div class=\"CallsComponent__heading\" style=\"margin-top:70px;margin-bottom:30px;\" data-v-042ba644>To get started</div><div class=\"CallsComponent__subtitle\" data-v-042ba644>Simply use your voice and say</div><div class=\"CallsComponent__voice\" data-v-042ba644> &quot;Schedule an appointment for me&quot; </div><div class=\"CallsComponent__heading\" data-v-042ba644>Or</div><div class=\"CallsComponent__subtitle\" style=\"margin-top:20px;\" data-v-042ba644>Use the Auto Assist Form</div>", 6);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_CallsAutoAssistForm = _resolveComponent("CallsAutoAssistForm");
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_ButtonBasic = _resolveComponent("ButtonBasic");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.showForm ? (_openBlock(), _createBlock(_component_CallsAutoAssistForm, {
    key: 0
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-phone",
    bounce: ""
  }), _createTextVNode(" Auto Schedule Assist")]), _hoisted_3, _createVNode(_component_ButtonBasic, {
    "class": "CallsComponent__button",
    label: "Open Auto Assist Form",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $data.showForm = true;
    })
  })]);
}